import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import WebIcon from '@material-ui/icons/Web';
import PostAddIcon from '@material-ui/icons/PostAdd';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import BuildIcon from '@material-ui/icons/Build';
import { Link, useLocation } from "react-router-dom";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import '../../assets/css/admin.css';

const NAV = [
  { label: 'Dashboard', href: '/admin/', icon: <DashboardIcon />, exact: true },
  { label: 'Allgemein', href: '/admin/site', icon: <WebIcon /> },
  { label: 'Beiträge', href: '/admin/posts', icon: <PostAddIcon /> },
  { label: 'Leistungen', href: '/admin/services', icon: <BuildIcon /> },
  { label: 'Mitarbeiter', href: '/admin/employees', icon: <PersonOutlineIcon /> },
  { label: 'Online Termin', href: '/admin/appointment', icon: <CalendarTodayIcon /> },
  { label: 'Formulare', href: '/admin/forms', icon: <ListAltIcon /> },
  { label: 'Galerie', href: '/admin/gallery', icon: <PhotoLibraryIcon /> },
];

function isActive(pathname, item) {
  if (item.exact) return pathname === item.href;
  return pathname === item.href || pathname.startsWith(`${item.href}/`);
}

export default function SideBar() {
  const location = useLocation();

  return (
    <List className="admin-nav" disablePadding>
      {NAV.map((item) => {
        const active = isActive(location.pathname, item);
        return (
          <ListItem
            button
            key={item.href}
            className={`admin-nav-item${active ? ' is-active' : ''}`}
            component={Link}
            to={item.href}
          >
            <ListItemIcon className="admin-nav-icon">{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        );
      })}
    </List>
  );
}
